<template>
<Field type="hidden" v-model="input" :rules="rules" :name="label+key+'_vInput'" :label="label" />
<ErrorMessage
  :name="label+key+'_vInput'"
  class="invalid-feedback-is-invalid"
  v-slot="{ message }"
>
  <span class="invalid-feedback-is-invalid">
    {{ messageCustom || message }}
  </span>
</ErrorMessage>
</template>

<script setup>
import { Field, ErrorMessage } from 'vee-validate'
import { onMounted, ref, watch, defineProps } from 'vue'

const key = new Date().getTime()
const props = defineProps(['modelValue', 'name', 'label', 'rules', 'vid', 'messageCustom'])
const input = ref(props.modelValue)

onMounted(() => {
  input.value = props.modelValue
})

watch(() => props.modelValue, (v) => {
  input.value = v
})
</script>
<style>
.invalid-feedback-is-invalid {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8125rem;
  color: #ff4c51
}
</style>